import { Flex, Spacer, Text, useColorMode } from '@chakra-ui/react'
import { Button, Panel, PlusIcon, SmartColumnsConfigurer, SparklesIcon } from 'components'
import { useCurrentUser, useWorkspace } from 'components/providers'
import noFacilityDark from '../assets/emptyStates/no_facilities_dark.svg'
import noFacilityLight from '../assets/emptyStates/no_facilities_light.svg'
import CreateNewButton from '../components/CreateNewButton'
import EmptyState from '../components/EmptyState'
import { createNewSmartColumn } from '../utils/lookupUtils'

export default function IntelligencePage() {
  const { workspace } = useWorkspace()
  const { colorMode } = useColorMode()
  const user = useCurrentUser()
  const hasSmartCols = workspace?.smartColumnsConfig?.lookUpIds?.length

  if (!user || !workspace) return null

  return (
    <Flex direction="column" gap={4} flex="auto" mb={2} p={{ base: 4, sm: 0 }} overflowY="auto">
      <Text textStyle="h2" p={2} pt={7}>
        Intelligence
      </Text>

      <Panel px={{ base: 0, sm: 10 }} py={10} gap={5} overflow="hidden">
        <Flex gap={3} w="100%" align="center" px={4}>
          <SparklesIcon color="primary.500" />
          <Text textStyle="h6">Smart Fields</Text>
          <Spacer />
          <Button
            leftIcon={<PlusIcon fontSize="xl" />}
            onClick={() => createNewSmartColumn(user.id, workspace)}
          >
            New Smart Column
          </Button>
        </Flex>
        {hasSmartCols ? (
          <Flex direction="column" gap={2} w="100%" px={4} overflowY="auto">
            {workspace.smartColumnsConfig?.lookUpIds.map(id => {
              return <SmartColumnsConfigurer key={id} lookUpId={id} />
            })}
          </Flex>
        ) : (
          <EmptyState
            title="No Smart Columns"
            description="No smart columns have been configured yet."
            iconSVG={colorMode === 'light' ? noFacilityLight : noFacilityDark}
            button={<CreateNewButton variant={'button'} />}
          />
        )}
      </Panel>
    </Flex>
  )
}
